import "./styles/PaymentSpinner.css";
import { ReactElement } from "react";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";

type PaymentSpinnerProps = {
  message?: string;
};

const PaymentSpinner = ({ 
  message = "Do not press back or refresh the page" 
}: PaymentSpinnerProps): ReactElement => {
  return (
    <div className="payment-spinner-overlay">
      <div className="payment-spinner">
        <DotLottieReact
          src="https://lottie.host/1ede44d1-b8b2-4a5d-8879-f488853ac2ff/2OOOc3vQXQ.json"
          loop
          autoplay
        />
        <h2 className="payment-spinner-message">{message}</h2>
      </div>
    </div>
  );
};

export default PaymentSpinner;
